import { createAPI } from '@common'

export default {
  // 获取根节点
  getRoot: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config),
  // 获取子节点
  getSubs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0epn0gpmefst', 'get', config),
  // 查询文件夹信息
  getFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0epn0gpmefs', 'get', config),
  // 新增文件夹
  postFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0epn0gpmefst', 'post', config),
  // 修改文件夹
  putFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0epn0gpmefst', 'post', config),
  // 删除文件夹
  deleteFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0epn0gpmefst', 'delete', config),
  // 查询人员信息
  getUsersWithPage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0vtfstXjuiQbhf', 'get', config),
  // 查询人员信息
  getUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0vtfst', 'get', config),
  // 移除人员和文件夹的关联关系
  postRemove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0sfnpwf', 'post', config),
  // 设置人员
  postRel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0sfm', 'post', config),
  getCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0gpmefs0difdl', 'get', config, {
      neverLoading: true
    }),
  getFlows: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60nbjo0gmpxt', 'get', config),
  // 权限控制-获取根节点
  getPermissionRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config),
  // 权限控制-获取树节点
  getNewsplanTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0epn0gpmefst', 'get', config),
  // 获取流程
  getE5AdminFlows: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60gmpxt', 'get', config),
  // 选题策划-操作权限控制
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config
    ),
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config
    ),
  // 选题策划-文件夹拖拽
  postFolderMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0npwf', 'post', config)
}
